export function isAbsolute(path: string) {
  return /https?:\/\//.test(path);
}